import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '../../components';
import './OnboardingForm.css';

const formClassname = 'onboarding-form';

interface OnboardingFormProps {
  saveDisabled: boolean;
  isSaving: boolean;
  saveOnClick: () => void;
  children: (ns: string) => React.ReactElement;
}

export default ({
  saveDisabled,
  isSaving,
  saveOnClick,
  children,
}: OnboardingFormProps) => {
  const { t } = useTranslation();
  const btnLabel = t('onboardingForm.saveButton');

  return (
    <div className={formClassname}>
      <Box withHeader className={`${formClassname}__box`}>
        {children(formClassname)}
        <div className={`${formClassname}__line-action`}>
          <Button
            onClick={saveOnClick}
            disabled={saveDisabled}
            loading={isSaving}
          >
            {btnLabel}
          </Button>
        </div>
      </Box>
    </div>
  );
};
